import { render, staticRenderFns } from "./Cleaning.vue?vue&type=template&id=19f12aaa&scoped=true&"
import script from "./Cleaning.vue?vue&type=script&lang=js&"
export * from "./Cleaning.vue?vue&type=script&lang=js&"
import style0 from "./Cleaning.vue?vue&type=style&index=0&id=19f12aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f12aaa",
  null
  
)

export default component.exports